// extracted by mini-css-extract-plugin
export default {"btn":"rJJB8rmr","mobile":"mobile"};